import {
  FETCH_ADMIN_SHARED_TENANT_DETAIL_REQUEST,
  FETCH_ADMIN_SHARED_TENANT_DETAIL_SUCCESS,
  FETCH_ADMIN_SHARED_TENANT_DETAIL_FAILURE,
  CLEAR_ADMIN_SHARED_TENANT_DETAIL,
} from '../../../../Constants/actionTypes';

const initialState = {
  loading: false,
  tenant: null,
  error: null,
  requestKey: null,
};

const fetchAdminSharedTenantDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADMIN_SHARED_TENANT_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        requestKey: action.payload.requestKey,
        tenant: null,
      };
    case FETCH_ADMIN_SHARED_TENANT_DETAIL_SUCCESS:
      if (action.payload.requestKey !== state.requestKey) return state;
      return {
        loading: false,
        tenant: action.payload.tenant,
        error: null,
        requestKey: action.payload.requestKey,
      };
    case FETCH_ADMIN_SHARED_TENANT_DETAIL_FAILURE:
      if (action.payload.requestKey !== state.requestKey) return state;
      return {
        loading: false,
        tenant: null,
        error: action.payload.error,
        requestKey: action.payload.requestKey,
      };
    case CLEAR_ADMIN_SHARED_TENANT_DETAIL:
      return initialState;
    default:
      return state;
  }
};

export default fetchAdminSharedTenantDetailReducer;
